import TrademarkLogo, { tmFontSize } from './TrademarkLogo';
import { useNavigate } from 'react-router-dom'; // NEW IMPORT

/**
 * Logo
 *
 * Default mode (no `align` prop): viewport-width sizing (20vw, clamped),
 * used standalone on the auth/payment shells.
 *
 * Aligned mode (`align={{ height, marginTop, marginLeft? }}`): the logo is
 * driven by an explicit px height so its top/bottom can be matched to a target
 * in the Header — the title block on desktop, or the nav-button row on mobile.
 * Width follows the image's natural 565:315 aspect ratio. The Header computes
 * these values dynamically (see Header.js). Aligned mode uses the neutral
 * `logo-aligned` class (NOT `logo-shrink`) so the mobile `!important` rules
 * below don't override the computed marginTop/height. `objectFit: 'contain'` +
 * `maxWidth: 100%` keep it from ever distorting or overflowing its column if
 * the derived width would exceed the available space.
 */
const Logo = ({ align = null }) => {
  const navigate = useNavigate(); // INITIALIZE HOOK

  const aligned = align && typeof align.height === 'number';

  const outerStyle = aligned
    ? {
        // Push the logo down so its top meets the alignment target.
        marginTop: `${align.marginTop}px`,
        width: 'auto',
        // Preserve the mobile left nudge when the caller asks for it.
        ...(align.marginLeft != null ? { marginLeft: align.marginLeft } : {}),
      }
    : {
        marginTop: '100px',  //just want it to be around the middle of the bar at the top and the text at the bottom
        width: '20vw',      //view width based size will make it scale
        minWidth: '120px',  //for phones
        maxWidth: '350px',   //for ultra-wide monitors
      };

  const imgStyle = aligned
    ? {
        // Height is the source of truth; width follows the aspect ratio.
        height: `${align.height}px`,
        width: 'auto',
        maxWidth: '100%',
        objectFit: 'contain',
        display: 'block',
        cursor: 'pointer',
      }
    : {
        width: '100%',   //img fills container
        height: 'auto',
        display: 'block',
        cursor: 'pointer',
      };

  return (

    // The outer div now controls how big the logo is relative to the screen
    <>
    <style>{`
    @media screen and (min-width: 300px) and (max-width: 600px) {
      .logo-shrink {
        margin-top: 40px !important;
        min-width: 60px !important;
        padding-left: 0px;
        padding-right: 0px;
        margin-left: -6vw;
      }
    }
  `}</style>
    <div style={outerStyle}
     className={aligned ? 'logo-aligned' : 'logo-shrink'}
     >
      <TrademarkLogo
        imgStyle={imgStyle}
        imgProps={{
          title: 'Go to Home Page',
          onClick: () => navigate('/'), // CHANGE: navigate to root
        }}
        // Aligned mode knows its px height; default mode tracks the outer
        // div's 20vw width (clamped 120..350px), so the ™ scales with it.
        tmSize={aligned ? `${tmFontSize({ height: align.height })}px` : 'clamp(12px, 2vw, 35px)'}
        wrapperStyle={aligned ? undefined : { display: 'block', width: '100%' }}
      />
    </div>
    </>
  );
};

export default Logo;
